<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="head-icons ms-2">
          <a
            href="javascript:void(0);"
            class=""
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-original-title="Collapse"
            id="collapse-header"
            @click="toggleHeader"
          >
            <i class="ti ti-chevrons-up"></i>
          </a>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <settings-tab></settings-tab>

      <div class="row">
        <system-sidebar></system-sidebar>

        <div class="col-xl-9">
          <div class="card">
            <div class="card-body">
              <div class="border-bottom mb-3 pb-3 d-flex align-items-center">
                <h4 class="mb-0 me-2">Email Settings</h4>
                <span
                  v-if="loading"
                  class="spinner-border spinner-border-sm"
                ></span>
              </div>

              <form @submit.prevent="submitMainForm">
                <div class="border-bottom mb-3 pb-3">
                  <div class="row">
                    <!-- SMTP card (only) -->
                    <div class="col-md-12 d-flex">
                      <div class="card flex-fill">
                        <div class="card-body">
                          <div class="border-bottom pb-3 mb-3">
                            <div
                              class="d-flex justify-content-between align-items-center mb-2"
                            >
                              <div class="d-flex align-items-center">
                                <span
                                  class="avatar avatar-xl me-2 p-2 bg-light flex-shrink-0"
                                >
                                  <img
                                    src="@/assets/img/settings/smtp.svg"
                                    alt="Profile"
                                  />
                                </span>
                                <h5 class="mb-0">SMTP</h5>
                              </div>

                              <!-- Always active (SaaS only) -->
                              <span
                                class="badge bg-success-subtle text-success border"
                              >
                                Active
                              </span>
                            </div>

                            <p class="mb-0">
                              Configure SMTP . This is used to send
                              all emails from your account.
                            </p>
                          </div>

                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <span
                              class="btn btn-sm btn-dark d-inline-flex align-items-center"
                            >
                              <i class="ti ti-checks me-1"></i>
                              Connected
                            </span>

                            <button
                              type="button"
                              class="btn btn-icon btn-sm text-gray-5 fs-20"
                              data-bs-toggle="modal"
                              data-bs-target="#smtpsettings"
                            >
                              <i class="ti ti-settings"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- (You can add another info card here later if you want) -->
                  </div>
                </div>

                <!-- Footer actions -->
                <div class="d-flex align-items-center justify-content-end">
                  <button
                    type="button"
                    class="btn btn-outline-primary me-3"
                    data-bs-toggle="modal"
                    data-bs-target="#test-email-modal"
                  >
                    Send Test Email
                  </button>

                  <button
                    type="button"
                    class="btn btn-outline-light border me-3"
                    :disabled="saving"
                    @click="reloadSettings"
                  >
                    Reset
                  </button>

                  <button
                    type="submit"
                    class="btn btn-primary"
                    :disabled="saving"
                  >
                    <span
                      v-if="saving"
                      class="spinner-border spinner-border-sm me-1"
                    ></span>
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->

  <!-- SMTP Modal -->
  <div class="modal fade" id="smtpsettings">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between"
        >
          <h4 class="modal-title mb-0">SMTP</h4>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="submitSmtpForm">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">From Email Address</label>
                  <input
                    class="form-control"
                    type="email"
                    v-model="smtp.from_address"
                  />
                </div>
              </div>

              <!-- ✅ ADD THIS so smtp_from_name is not null -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">From Email Name</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="smtp.from_name"
                  />
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">
                    Email Password
                    <small class="text-muted" v-if="smtp.has_password">
                      (leave blank to keep existing)
                    </small>
                  </label>
                  <input
                    class="form-control"
                    type="password"
                    v-model="smtp.password"
                  />
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Email Host</label>
                  <input class="form-control" type="text" v-model="smtp.host" />
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Port</label>
                  <input
                    class="form-control"
                    type="number"
                    v-model="smtp.port"
                  />
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Username</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="smtp.username"
                  />
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Encryption</label>
                  <select class="form-select" v-model="smtp.encryption">
                    <option :value="null">None</option>
                    <option value="ssl">SSL</option>
                    <option value="tls">TLS</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="d-flex align-items-center justify-content-end">
              <button
                type="button"
                class="btn btn-outline-light border me-3"
                data-bs-dismiss="modal"
                :disabled="saving"
              >
                Cancel
              </button>

              <button type="submit" class="btn btn-primary" :disabled="saving">
                <span
                  v-if="saving"
                  class="spinner-border spinner-border-sm me-1"
                ></span>
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /SMTP Modal -->

  <!-- Test Email Modal -->
  <div class="modal fade" id="test-email-modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Send Test Email</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal">
            <i class="ti ti-x"></i>
          </button>
        </div>

        <form @submit.prevent="submitTestEmail">
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Recipient Email</label>
              <input
                type="email"
                class="form-control"
                v-model="testEmail"
                required
              />
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-light border"
              data-bs-dismiss="modal"
              :disabled="testing"
            >
              Cancel
            </button>

            <button type="submit" class="btn btn-primary" :disabled="testing">
              <span
                v-if="testing"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              Send Test Email
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Test Email Modal -->
</template>

<script setup>
import { onMounted, onUnmounted, reactive, ref } from "vue";
import * as bootstrap from "bootstrap";
import { toast } from "@/utils/toast";
import emailSettingsService from "@/services/emailSettingsService";

const title = "Settings";
const text = "Administration";
const text1 = "Settings";

const loading = ref(false);
const saving = ref(false);

const testEmail = ref("");
const testing = ref(false);

// ------------------ STATE ------------------
const activeMailer = ref("smtp"); // ✅ SMTP only

const smtp = reactive({
  from_address: "",
  from_name: "",
  host: "",
  port: "",
  username: "",
  password: "",
  has_password: false,
  encryption: null,
});

// ------------------ HEADER TOGGLE ------------------
function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

// ------------------ APPLY SETTINGS ------------------
function applySettings(data) {
  // SaaS: always smtp
  activeMailer.value = "smtp";

  smtp.from_address = data.smtp_from_address || "";
  smtp.from_name = data.smtp_from_name || "";
  smtp.host = data.smtp_host || "";
  smtp.port = data.smtp_port || "";
  smtp.username = data.smtp_username || "";
  smtp.password = "";
  smtp.has_password = !!data.has_smtp_password;
  smtp.encryption = data.smtp_encryption || null;
}

async function loadSettings() {
  loading.value = true;
  try {
    const res = await emailSettingsService.get();
    applySettings(res.data || {});
  } catch (error) {
    const msg =
      error?.response?.data?.message ||
      "Failed to load email settings. Please check your connection.";
    toast(msg, "error");
  } finally {
    loading.value = false;
  }
}

function reloadSettings() {
  loadSettings();
}

function validateEmailSettings() {
  if (!smtp.from_address) return "From Email Address is required for SMTP.";
  if (!smtp.host) return "Email Host is required for SMTP.";
  if (!smtp.port) return "Port is required for SMTP.";
  if (!smtp.username) return "Username is required for SMTP.";
  if (!smtp.password && !smtp.has_password)
    return "Email Password is required for SMTP.";
  return null;
}

function buildPayload() {
  return {
    active_mailer: "smtp", // ✅ force
    smtp_from_address: smtp.from_address || null,
    smtp_from_name: smtp.from_name || null,
    smtp_host: smtp.host || null,
    smtp_port: smtp.port ? Number(smtp.port) : null,
    smtp_username: smtp.username || null,
    smtp_password: smtp.password || null,
    smtp_encryption: smtp.encryption || null,
  };
}

async function saveSettings() {
  const errorMsg = validateEmailSettings();
  if (errorMsg) {
    toast(errorMsg, "error");
    return false;
  }

  saving.value = true;
  try {
    const payload = buildPayload();
    await emailSettingsService.update(payload);
    toast("Email settings updated successfully");

    // clear temporary password field
    smtp.password = "";

    await loadSettings();
    return true;
  } catch (error) {
    const msg =
      error?.response?.data?.message ||
      "Failed to update email settings. Please try again.";
    toast(msg, "error");
    return false;
  } finally {
    saving.value = false;
  }
}

// ------------------ FORM SUBMITS ------------------
async function submitMainForm() {
  await saveSettings();
}

async function submitSmtpForm() {
  const ok = await saveSettings();
  if (ok) closeModal("smtpsettings");
}

// ------------------ TEST EMAIL ------------------
async function submitTestEmail() {
  if (!testEmail.value) {
    toast("Enter a valid email.", "error");
    return;
  }

  testing.value = true;
  try {
    await emailSettingsService.sendTestEmail(testEmail.value);
    toast("Test email sent successfully!");
    closeModal("test-email-modal");
    testEmail.value = "";
  } catch (error) {
    const msg =
      error?.response?.data?.message ||
      "Failed to send test email. Check your configuration.";
    toast(msg, "error");
  } finally {
    testing.value = false;
  }
}

// ------------------ MODAL CLEANUP ------------------
function cleanupModals() {
  const backdrops = document.querySelectorAll(".modal-backdrop");
  backdrops.forEach((bd) => bd.parentNode && bd.parentNode.removeChild(bd));

  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("padding-right");
}

function closeModal(id) {
  const el = document.getElementById(id);
  if (!el) return;

  const instance = bootstrap.Modal.getInstance(el);
  if (instance) instance.hide();
  else new bootstrap.Modal(el).hide();

  window.setTimeout(() => cleanupModals(), 200);
}

let modalHiddenHandler = null;

onMounted(() => {
  loadSettings();
  modalHiddenHandler = function () {
    cleanupModals();
  };
  document.addEventListener("hidden.bs.modal", modalHiddenHandler);
});

onUnmounted(() => {
  if (modalHiddenHandler) {
    document.removeEventListener("hidden.bs.modal", modalHiddenHandler);
  }
});
</script>


